import VirtualizedTable from '../../components/common/VirtualizedTable';
import {Box, Typography, Paper } from "@mui/material";

const TopErrorsAnalyticsTable = ({ data, loading, name='Аналитика по топ-3 ошибок' }) => {
  console.log("TopErrorsAnalyticsTable data:", data);
  // Агрегация данных по операторам и критериям
  const aggregatedData = data.reduce((acc, item) => {
    const agentName = item.assessment.agent_name;
    
    // Инициализация объекта для оператора, если его еще нет
    if (!acc[agentName]) {
      acc[agentName] = {
        errors: {},
        lowScores: {},
        total: {}
      };
    }
    
    // Проходим по каждому критерию в оценке
    item.assessment.items.forEach(criteriaItem => {
      const { criteria_name, score, positive } = criteriaItem;
      
      // Инициализация счетчиков для критерия, если их еще нет
      if (!acc[agentName].errors[criteria_name]) {
        acc[agentName].errors[criteria_name] = 0;
        acc[agentName].lowScores[criteria_name] = 0;
        acc[agentName].total[criteria_name] = 0;
      }

      // Увеличиваем общий счетчик для критерия
      acc[agentName].total[criteria_name] += 1;

      // Рассчитываем значение для проверки
      let checkValue = positive ? score : (1 - score);
      let errorValue = positive ? (1 - score)  : score;

      // Если значение < 1 — это неидеальная оценка, считаем как ошибку
      if (checkValue < 1) {
        acc[agentName].lowScores[criteria_name] += 1;
        acc[agentName].errors[criteria_name] += errorValue;
      }
    });
    
    return acc;
  }, {});
  
  console.log('TopErrorsAnalyticsTable aggregated data:', aggregatedData);

  // Преобразование в массив для таблицы
  const rows = Object.entries(aggregatedData)
    .map(([agent_name, criteriaData]) => {
      // Преобразуем объект критериев в массив и сортируем по количеству низких баллов
      const sortedCriteria = Object.entries(criteriaData.lowScores)
        .sort((a, b) => b[1] - a[1]); // Сортировка по убыванию
      
      // Создаем объект строки с топ-3 критериями
      const row = {
        id: agent_name,
        agent_name,
        top1_criteria: '',
        top1_percentage: '',
        top2_criteria: '',
        top2_percentage: '',
        top3_criteria: '',
        top3_percentage: '',
      };
      
      // Заполняем поля топ-3
      if (sortedCriteria[0] && sortedCriteria[0][1] > 0) {
        const criteriaName = sortedCriteria[0][0];
        const lowScoreCount = sortedCriteria[0][1];
        const errorValue = criteriaData.errors[criteriaName] || 0;
        const totalCount = criteriaData.total[criteriaName];
        const percentage = totalCount > 0 ? ((errorValue / totalCount) * 100).toFixed(1) : '0';
        row.top1_criteria = `${criteriaName} (${lowScoreCount}) снялось ${errorValue.toFixed(1)}`;
        row.top1_percentage = `${percentage}%`;
      }

      if (sortedCriteria[1] && sortedCriteria[1][1] > 0) {
        const criteriaName = sortedCriteria[1][0];
        const lowScoreCount = sortedCriteria[1][1];
        const errorValue = criteriaData.errors[criteriaName] || 0;
        const totalCount = criteriaData.total[criteriaName];
        const percentage = totalCount > 0 ? ((errorValue / totalCount) * 100).toFixed(1) : '0';
        row.top2_criteria = `${criteriaName} (${lowScoreCount}) снялось ${errorValue.toFixed(1)}`;
        row.top2_percentage = `${percentage}%`;
      }

      if (sortedCriteria[2] && sortedCriteria[2][1] > 0) {
        const criteriaName = sortedCriteria[2][0];
        const lowScoreCount = sortedCriteria[2][1];
        const errorValue = criteriaData.errors[criteriaName] || 0;
        const totalCount = criteriaData.total[criteriaName];
        const percentage = totalCount > 0 ? ((errorValue / totalCount) * 100).toFixed(1) : '0';
        row.top3_criteria = `${criteriaName} (${lowScoreCount}) снялось ${errorValue.toFixed(1)}`;
        row.top3_percentage = `${percentage}%`;
      }
      
      return row;
    });

  const columns = [
    {
      accessorKey: 'agent_name',
      header: 'Оператор',
      size: 200,
      enableSorting: true,
    },
    {
      accessorKey: 'top1_criteria',
      header: 'Топ-1',
      size: 250,
      enableSorting: true,
    },
    {
      accessorKey: 'top1_percentage',
      header: '%',
      size: 70,
      enableSorting: true,
    },
    {
      accessorKey: 'top2_criteria',
      header: 'Топ-2',
      size: 250,
      enableSorting: true,
    },
    {
      accessorKey: 'top2_percentage',
      header: '%',
      size: 70,
      enableSorting: true,
    },
    {
      accessorKey: 'top3_criteria',
      header: 'Топ-3',
      size: 250,
      enableSorting: true,
    },
    {
      accessorKey: 'top3_percentage',
      header: '%',
      size: 70,
      enableSorting: true,
    },
  ];

  return (
      <>
        {data.length > 0 && (
          <Box sx={{ height: '100%', width: '100%', mt: 4 }}>
            <Paper sx={{ p: 2, height: '100%', width: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Статистика по топу ошибок у операторов
              </Typography>
              <VirtualizedTable
                data={rows}
                columns={columns}
                noDataText="Нет данных для отображения"
                tableName={name}
                frozenColumnCount={0}
              />
            </Paper>
          </Box>
        )}

        {!data.length && !loading && (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
            Нет данных для отображения аналитики
          </Typography>
        )}
      </>
  );
};

export default TopErrorsAnalyticsTable;
